import script from "./UiFormField.vue?vue&type=script&setup=true&lang=js"
export * from "./UiFormField.vue?vue&type=script&setup=true&lang=js"

import "./UiFormField.vue?vue&type=style&index=0&id=65e918e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e918e0"]])

export default __exports__